/** @format */

import React from "react";
import PageLayout from "../../components/PageLayout";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div className='policyes legal'>
      <PageLayout>
        <div className='container'>
          <h2 className='titletwo'>
            <span>Privacy</span> Policy
          </h2>

          <p>
            Seize LLC
            <br /> Privacy Policy
            <br /> Effective Date:  January 10, 2025
          </p>
          <p>
            Seize LLC (“we,” “us,” “our”) respects your privacy and takes the
            responsibility of protecting the personal information that you
            provide to us via our website and Paths mobile application
            (collectively, the “Services”) and our other in-person activities,
            services, features, or resources very seriously.
          </p>
          <p>
            This Privacy Policy is intended to outline our practices regarding
            the collection, use, disclosure, and protection of information
            received from users of the Services, including users in the European
            Economic Area (“EEA”) and residents of the State of California
            (collectively, “you” or “user”). We adopt this Privacy Policy to
            comply with the California Consumer Privacy Act of 2018 (“CCPA”) and
            the EU General Data Protection Regulation (“GDPR”). For the purposes
            of compliance with the GDPR, we are the “controller” of Personal
            Data (i.e., Personal Information) we receive from you.
          </p>
          <p>
            We encourage you to carefully review this Privacy Policy to have a
            clearer understanding of our privacy practices. By accessing,
            downloading, or using the Services, you agree to this Privacy
            Policy. If you do not agree with our policies and practices, do not
            access, continue to access, or use our website, or download our
            mobile application.
          </p>
          <p>
            For the purposes of this Privacy Policy, and identified or
            identifiable natural person in the EEA as set forth in the GDPR, and
            accessing the Services, will be referred to as a Data Subject.
          </p>
          <h5>Scope </h5>
          <p>
            The Privacy Policy applies to the Services, which includes our
            mobile application and getpaths.com, its subdomains, and all of the
            websites and internet properties owned or operated by us, regardless
            of the medium in which the Services are accessed by a user (e.g.,
            via a web or mobile browser), as well as our other in-person
            activities, services, features, or resources.
          </p>
          <h5>Information We Collect</h5>
          <p>
            <u>
              The Paths app software encrypts all text data, end to end, using
              256 bit encryption methods.
            </u>
            We collect several types of information from and about users of the
            Services.
          </p>
          <p>
            Personal Information: We may collect Personal Information from you
            in order to provide you with the information or services you may
            request. “Personal Information” refers to information that
            identifies, relates to, describes, is capable of being associated
            with, or could reasonably be linked, directly or indirectly, with a
            particular individual or device. Personal Information is similarly
            defined within the GDPR. When you use, navigate, and/or complete
            forms on the Services, we may collect Personal Information about
            you. The categories and types of Personal Information we may collect
            along with the purposes for which we use your Personal Information
            include:
          </p>
          <h5>Category</h5>
          <p>Type(s)</p>
          <strong>Purposes</strong>
          <ul className='Identifiers'>
            <li>Identifiers</li>
          </ul>
          <strong>
            Name, email address, phone number, IP address, photographs, videos
          </strong>
          <ul className='Identifiers'>
            <li>
              Delivery of Services
              <ul>
                <li>
                  First name & Last Name (Used so you and your friends can
                  locate, identify and verify each other)
                </li>
                <li>Photographs & videos (Used to save and share memories)</li>
                <li>
                  Email address (Used as account ID, two-factor authentication,
                  system reminders and communications)
                </li>
              </ul>
            </li>
            <li>Two-Factor Authentication Security</li>
            <li>Customer Services/User Communications</li>
            <li>Newsletters</li>
            <li>Direct Marketing</li>
            <li>
              California Customer Records statutory categories of personal
              information
            </li>
          </ul>
          <strong>Name, email address, phone number</strong>
          <p>(California residents only)</p>
          <ul className='Identifiers'>
            <li>
              Delivery of Services
              <ul>
                <li>
                  First name & Last Name (Used so you and your friends can
                  locate, identify and verify each other)​
                </li>
                <li>Photographs & videos (Used to save and share memories)</li>
                <li>
                  Email address (Used as account ID, two-factor authentication,
                  system reminders and communications)
                </li>
              </ul>
            </li>
            <li>Two-Factor Authentication Security</li>
            <li>Customer Services/User Communications</li>
            <li>Newsletters</li>
            <li>Direct Marketing</li>
            <li>Internet or similar network activity</li>
          </ul>
          <strong>
            Browsing history, search history, information collected from cookies
            and web beacons, information on an individual’s interactions with
            the Services
          </strong>
          <ul className='Identifiers'>
            <li>User Experience Personalization</li>
            <li>Business Optimization</li>
            <li>Geolocation data</li>
          </ul>
          <strong>Location data</strong>
          <ul className='Identifiers'>
            <li>Delivery of Services</li>
            <li>User Experience Personalization</li>
            <li>Business Optimization</li>
          </ul>
          <p>
            Personal Information does not include publicly available information
            from government records; de-identified or aggregate information; or
            certain personal information protected by other sector-specific
            federal or state statutes.
          </p>
          <p>
            Deidentified Information: We may collect De-identified Information
            when you use and navigate the Services. “Deidentified Information”
            is information that cannot reasonably identify, relate to, describe,
            be capable of being associated with, or be linked, directly or
            indirectly, to a particular individual. Deidentified Information may
            include, without limitation, information regarding your device, the
            type of internet browser you are using, the type of computer
            operating system you are using to access the Services or the
            internet service provider utilized. We will take reasonable measures
            to ensure that De-identified Information we collect is not
            personally identifiable and may not later be easily used to identify
            you as otherwise required by applicable law.
          </p>
          <p>
            Aggregate Information: We may collect “Aggregate Information” which
            means information that relates to a group or category of
            individuals, from which an individual’s identity has been removed,
            that is not linked or reasonably linkable to any individual,
            including via a device.
          </p>
          <p>
            Children Under the Age of 16: The Services are not intended for
            children under 16 years of age. We do not market to and do not
            knowingly collect, disclose, or sell any Personal Information from,
            or about a child under the age of 16 without the consent of the
            child’s parent or legal guardian. If we discover that we have
            inadvertently collected information from a child under 16 years of
            age, we will promptly take all reasonable measures to delete such
            information from our systems.
          </p>
          <h5>How We Collect Information</h5>
          <p>
            We collect Personal Information, Deidentified Information, and
            Aggregate Information (collectively, “Your Information”) from the
            following categories of sources:
          </p>
          <p>
            Directly From You: We may collect Personal Information from you when
            you voluntarily provide Personal Information to us by, for example,
            completing forms or services and products you purchase.
            <br />
            Indirectly From You: We may collect Personal Information and
            Deidentified Information from you when you interact with the
            Services. We collect Personal Information (such as browsing history,
            search history, and information on your interactions with the
            Services) that your browser transmits when you visit the Services.
            We may collect Personal Information and Deidentified Information
            about how you access and interact with the Services through the use
            of automated tracking technology, such as “cookies” and “web
            beacons.”
          </p>
          <p>
            A cookie is a small data file that is transferred to a web browser,
            which enables the Services to remember and customize your subsequent
            visits. Most internet browsers automatically accept cookies. You can
            instruct your browser to block the acceptance of cookies or to
            provide you with a warning prompt before you accept cookies from the
            Services. Please refer to your internet browser’s instructions to
            learn more about these functions. If you reject cookies, the
            functionality of the Services may be limited and you may not be able
            to participate in several of the Services’ features. Additionally,
            we may use web beacons, which are single-pixel, electronic images
            embedded in the Services that allow us to gather information about
            your browsing activities on the Services.
          </p>
          <p>
            From Third-Party Services: We may collect Personal Information about
            you from third parties whose privacy practices may differ from the
            practices described in this Privacy Policy. We do not endorse or
            make any representations or warranties concerning, and will not in
            any way be liable for, any informational content, products,
            services, software, or other materials available through third
            parties. Your use of third parties’ services and/or third-party
            websites and mobile applications is governed by and subject to the
            terms and conditions of those third parties and/or third-party
            websites and mobile applications. We encourage you to carefully
            review the privacy policies and statements of such third parties
            and/or
          </p>
          <h5>Third-party websites and mobile applications.</h5>
          <p>
            We will not collect additional categories of Personal Information or
            use the Personal Information we collected for materially different,
            unrelated, or incompatible purposes without providing you notice.
          </p>
          <h5>How We Use Your Information</h5>
          <p>
            We use Your Information for various business purposes to help
            enhance your experience. These purposes include, but are not limited
            to:
          </p>
          <p>
            <strong>Delivery of Services:</strong> We may use Your Information
            to deliver our services, products, and features to you. Customer
            Service and User Communications: We may use your Personal
            Information to help us respond to your inquiries, questions,
            requests and support needs more efficiently.
            <br />
            User Experience Personalization: We may use Your Information to
            analyze users’ browsing and usage activities and patterns in order
            to understand users’ interests and preferences with respect to the
            Services. This will help us optimize the users’ experience on the
            Services.
          </p>
          <p>
            <strong>Newsletters:</strong> We may use your Personal Information
            to send you news and updates related to our services via our
            newsletter. You have the option to opt-out of receiving our
            newsletter. Direct Marketing: We may use your Personal Information
            to send you promotional materials. You have the option to opt-out of
            receiving direct marketing.
          </p>
          <p>
            <strong>Business Optimization:</strong> We may use Your Information
            in managing our everyday business needs. We may also use your
            feedback to improve the Services.
          </p>
          <h5>How We Disclose Information</h5>
          <p>
            We may share and disclose Your Information to third parties for a
            business purpose or to fulfill legal obligations. When we disclose
            Personal Information for a business purpose, we enter a contract
            that describes the business purpose and requires the recipient to
            both keep that Personal Information confidential and not use it for
            any purpose except performing the contract. We may share and
            disclose Your Information in the following circumstances:
          </p>
          <p>
            <strong>To Service Providers:</strong> Your Information may be
            shared with third-party service providers that assist us in
            providing customer support, communicating with individuals, and
            promoting our services, as well as third-party service providers
            that provide other services to us relating to the Services.
          </p>
          <p>
            <strong>Law Enforcement, Safety, and Legal Processes:</strong> Your
            Information may be shared with law enforcement or other government
            officials if it relates to a criminal investigation or alleged
            criminal activity. We may also share Your Information if required or
            permitted to do so by law, for fraud protection and credit risk
            reduction purposes, or in the good-faith belief that such action is
            necessary to protect and defend our property rights or the rights of
            the users of the Services. We may further share Your Information to
            act under urgent circumstances to protect the safety of our
            employees or a member of the public or to comply with a judicial
            proceeding, court order, or legal process.
          </p>
          <p>
            <strong>In a Sale or Acquisition of Assets:</strong> If we become
            involved in a transaction involving the sale of our assets, such as
            a merger or acquisition, or if we are transferred to another
            company, we may disclose and/or transfer Your Information as part of
            the transaction. If the surviving entity in that transaction is not
            us, the surviving company may use Your Information pursuant to their
            own privacy policies, and those policies may be different from this
            Privacy Policy.
          </p>
          <p>
            We may disclose the following categories of Personal Information for
            a business purpose: Identifiers; California Customer Records statute
            personal information categories; Protected classifications
            characteristics; Internet or similar network activity; and
            Geolocation data.
          </p>
          <h5>Sale of Personal Information</h5>
          <p>We do not sell Personal Information to any third party.</p>
          <p>
            <strong>EEA Data Subject Rights and Choices</strong>
            <br />
            Under certain circumstances, Data Subjects from the EEA may have the
            following rights under the GDPR:
          </p>
          <ul className='Identifiers'>
            <li>
              Right to access the Personal Information we maintain about you;
            </li>
            <li>
              Right to be provided with information about how we process your
              Personal Information;
            </li>
            <li>Right to correct your Personal Information;</li>
            <li>Right to have your Personal Information erased;</li>
            <li>
              Right to object to or restrict how we process your Personal
              Information; and
            </li>
            <li>
              Right to request your Personal Information to be transferred to a
              third-party.
            </li>
          </ul>
          <p>
            To exercise the above rights, please contact us at the information
            provided below. We will consider and process your request within a
            reasonable period of time. Please be aware that under certain
            circumstances, the GDPR may limit your exercise of these rights.
          </p>
          <p>
            How to Withdraw Consent: At any time, Data Subjects from the EEA may
            withdraw consent you have provided to us for using, disclosing, or
            otherwise processing your Personal Information. You may withdraw
            your consent by communicating your request at the information
            provided below.
          </p>
          <p>
            Please note that your withdrawal of consent to process certain
            Personal Information about you (1) may limit our ability to deliver
            services to you and (2) does not affect the lawfulness of our
            processing activities based on your consent before its withdrawal.
            Note that even after withdrawing consent, we may use, disclose, or
            otherwise process your Personal Information if required by law to do
            so.
          </p>
          <p>
            How to File a Complaint: Additionally, Data Subjects from the EEA
            may file a complaint with EU data protection authorities (“DPAs”). A
            list of DPAs from the European Commission may
            <br />
            be found here:{" "}
            <Link to='http://ec.europa.eu/newsroom/article29/document.cfm?action=display&doc_id=50061'>
              http://ec.europa.eu/newsroom/article29/document.cfm?action=display&doc_id=50061.
            </Link>
          </p>
          <h5>California Resident Rights and Choices</h5>
          <p>
            Under certain circumstances, California residents may have specific
            rights regarding their Personal Information. California residents
            have the following rights under the CCPA:
          </p>
          <ul className='Identifiers'>
            <li>
              Right to Access Specific Information. You have the right to
              request that we disclose certain information to you about our data
              processing practices over the past 12 months.
            </li>
            <li>
              Right to Data Portability. You have the right to receive
              information you request in a portable and readily usable format
              that allows you to transmit the information to another entity
              without hindrance.
            </li>
            <li>
              <span>
                Right to Deletion. You have the control to delete your account
                and all data attached to it from the mobile app software.
              </span>
              <ul>
                <li>
                  Instructions are included at the end of this document and also
                  on the Account Deletion Tutorial Page.
                </li>
                <li>
                  You also have the right to request that we delete any of your
                  Personal Information that we collected from you and retained,
                  subject to certain exceptions.
                </li>
              </ul>
            </li>
            <li>
              Right to be Free from Discrimination. You have the right to be
              free from discrimination for exercising your rights under the
              CCPA. However, we may offer you certain financial incentives
              permitted by the CCPA that may result in different prices, rates,
              or quality levels.
            </li>
          </ul>
          <h5>Exercising Your Rights Under the CCPA and GDPR</h5>
          <p>
            <strong>Verifiable Consumer Requests:</strong> To exercise your
            rights of access, data portability, and deletion described above,
            please submit a verifiable consumer request to us by either:
          </p>
          <ul className='Identifiers'>
            <li>Calling us at: 360-693-4225</li>
            <li>
              Visiting:{" "}
              <Link to='https://www.getpaths.com/'>
                https://www.getpaths.com/
              </Link>
            </li>
            <li>
              Emailing us at:{" "}
              <a href='mailto:info@getpaths.com'>info@getpaths.com</a>
            </li>
          </ul>
          <p>
            Only you, or someone legally authorized to act on your behalf, may
            make a verifiable consumer request related to your Personal
            Information. You may also make a verifiable consumer request on
            behalf of your minor child.
          </p>
          <p>
            You may only make a verifiable consumer request for access or data
            portability twice within a 12-month period. The verifiable consumer
            request must: (1) provide sufficient information that allows us to
            reasonably verify you are the person about whom we collected
            personal information or an authorized representative; and (2)
            describe your request with sufficient detail that allows us to
            properly understand, evaluate, and respond to it. We cannot respond
            to your request if we cannot verify your identity or authority to
            make the request. Making a request does not require you to create an
            account with us.
          </p>
          <p>
            <strong>Response Timing and Format:</strong> We endeavor to respond
            to verifiable consumer requests within forty-five (45) days of
            receipt. If we require more time, we may take up to an additional
            forty-five (45) days to respond. We will inform you of the reason
            for the extension period in writing.
          </p>
          <p>
            If you have an account with us, we will deliver our written response
            to that account. If you do not have an account with us, we will
            deliver our written response by mail or electronically, at our
            option. Any disclosures we provide will only cover the 12-month
            period preceding the verifiable consumer request's receipt. The
            response we provide will also explain the reasons we cannot comply
            with your request, if applicable.
          </p>
          <p>
            Once we receive and confirm your verifiable consumer request, we
            will disclose to you:
          </p>
          <ul className='Identifiers'>
            <li>
              The categories of personal information we collected about you;
            </li>
            <li>
              The categories of sources for the personal information we
              collected about you;
            </li>
            <li>
              Our business or commercial purpose for collecting that personal
              information;
            </li>
            <li>
              The categories of third parties with whom we share that personal
              information;
            </li>
          </ul>
          <p>
            For data portability requests, we will select a format to provide
            your personal information that is readily useable and should allow
            you to transmit the information from one entity to another entity
            without hindrance
          </p>
          <p>
            For deletion requests, we will delete (and direct our service
            providers to delete) your Personal Information from our records,
            unless an exception applies. We may deny your deletion request if
            retaining the information is necessary for us or our service
            provider(s) pursuant to enumerated exceptions detailed in the CCPA
            and GDPR.
          </p>
          <p>
            We do not charge a fee to process a verifiable consumer request
            unless it is excessive, repetitive, or manifestly unfounded. If a
            request warrants a fee, we will provide you with an explanation and
            a cost estimate for completing your request.
          </p>
          <h5>International Data Transfers</h5>
          <p>
            For Data Subjects from the EEA, we may transfer your Personal
            Information outside the EEA for processing pursuant to the purposes
            outlined above. When you provide us Personal Information, you
            understand and agree that it may be transferred across national
            boundaries and processed outside the EEA, including by trusted third
            parties.
          </p>
          <h5>Retention Policy</h5>
          <p>
            We will only retain your Personal Information for as long as
            necessary to fulfill the purposes for which we collected it,
            including for the purposes of satisfying any legal, accounting, or
            reporting requirements. Details of retention periods for different
            aspects of your Personal Information are available in our retention
            policy which you can request at the contact information provided
            below.
          </p>
          <h5>Additional California Privacy Rights</h5>
          <p>
            California’s “Shine the Light” law permits users of the Services
            that are California residents to request certain information
            regarding our disclosure of Personal Information to third parties
            for their direct marketing purposes. To make such a request, please
            contact us at the contact information provided below.
          </p>
          <h5>Data Security</h5>
          <p>
            <u>
              The Paths app software encrypts all text data, end to end, using
              256 bit encryption methods.
            </u>{" "}
            The Services use commercially reasonable security measures to
            protect Your Information. However, no data transmitted over or
            accessible through the internet can be guaranteed to be 100% secure.
            As a result, while we attempt to protect Your Information, we cannot
            ensure or warrant that Your Information will be completely secure
            from misappropriation by hackers or from other nefarious or criminal
            activities, or in the event of a failure of computer hardware,
            software, or a telecommunications network.
          </p>
          <h5>SPAM</h5>
          <p>
            We do not participate in bulk email solicitations that you have not
            consented to receive (i.e., “spam”). We do not sell or disclose
            customer lists or email address lists to unrelated third parties.
            Except as otherwise provided herein, we do not share Personal
            Information with any third-party advertisers.
          </p>
          <h5>Modifications</h5>
          <p>
            This Privacy Policy was last reviewed and modified as of the
            Effective Date first printed above. Please note that we may update
            this Privacy Policy from time-to-time in our sole discretion. It is
            your responsibility to review this Privacy Policy for any changes
            each time that you use the Services.
          </p>
          <h5>External Links</h5>
          <p>
            The Services may contain links to other websites. We do not endorse
            or make any representations or warranties concerning, and will not
            in any way be liable for, any informational content, products,
            services, software, or other materials available on external
            websites, even if one or more pages of the external websites are
            framed within a page of the Services. Please be aware that we are
            not responsible for the privacy practices or policies of such other
            websites.
          </p>
          <p>Accessing and Updating Information</p>
          <p className='orange'>
            If you ever wish to access Your Information or have Your Information
            deleted, updated, changed, or modified, you may do so by contacting
            us at the contact information provided below. You can also delete
            your account yourself by using the process shown at{" "}
            <Link to='https://www.getpaths.com/delete'>
              www.getpaths.com/delete
            </Link>
            . Further, if you would like to opt-out of receiving direct
            marketing communications from us, you may do so by following any
            instructions included in the communication or by contacting us at
            the contact information provided below. To cancel your account and
            have your information returned to you, please contact us at the
            contact information provided below. We will make commercially
            reasonable efforts to handle requests to update or modify Your
            Information within thirty (30) days.
          </p>
          <h5>Contact for More Information</h5>
          <p>
            If you would like to contact us with questions or comments
            concerning the accuracy and/or privacy of Your Information, or if
            you believe that we have not adhered to this Privacy Policy, please
            notify us by contacting the following:
          </p>

          <p>
            Attn: Taber Nash, CEO
            <br /> Seize LLC
            <br />
            <Link to='https://www.getpaths.com/'>
              https://www.getpaths.com/
            </Link>
            <br />
            <a href='mailto:info@getpaths.com'>info@getpaths.com</a>
          </p>
          <p>
            <strong>We welcome your questions and comments.</strong>
          </p>
          {/* <div className="policy-video">
            <h5>How To Delete Your Paths Account</h5>
            <div className="videoleft">
              <iframe
                src="https://www.youtube.com/embed/d-MGshFFuJo"
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="YouTube video player"
              ></iframe>
            </div>
            <div className="videoinfo">
              <p>
                Watch the video tutorial on how to delete your Paths account
              </p>
              <p>
                Visit here to view a step-by-step tutorial on how to delete your
                Paths account
              </p>
            </div> 
          </div> */}
        </div>
      </PageLayout>
    </div>
  );
}
